const SpotifyService = {

  serach(query) {
    return new Promise((resolve, reject) => {
      spotify.get(`search?q=${query}&type=track&market=DE&limit=50`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  request(url) {
    return new Promise((resolve, reject) => {
      spotify.get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default SpotifyService;
